import React from 'react';
import {connect} from "react-redux";
import Report from "./Report";
import {getRequest} from "../../Api/Api";
import {setState} from "../../redux/report-reducer";

class ReportContainer extends React.Component {

    componentDidMount() {
        getRequest("json", this.props.match.params.id).then(json => {
            this.props.setState(json);
        });
    }

    render() {
        return (<Report {...this.props} />);
    }
}

const mapStateToProps = state => {

    let obj = {
        report:state.report,
    }

    return obj;
}

export default connect(mapStateToProps, {setState})(ReportContainer);